import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import { useField } from 'formik';

import * as graphql from 'generated/graphql';
import { SubSectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import Toggle from 'packages/kakapo-ui-kit/components/forms/controls/Toggle';

import Property from './Property';

function Party(props: { title: string; name: string; checked: boolean; onChange: () => void }) {
	return (
		<Flex alignItems="center" flexGrow={1} flexShrink={1} flexBasis={1}>
			<Box flexGrow={1}>
				<SubSectionTitle>{props.title}</SubSectionTitle>
			</Box>
			<Box>
				<Toggle
					checked={props.checked}
					onChange={() => props.onChange()}
					name={props.name}
					value=""
					unspaced
				/>
			</Box>
		</Flex>
	);
}

export default function FilledInBy() {
	const { t } = useTranslation();

	const [field, , { setValue }] = useField('fillInBy');

	return (
		<Property title={t('common.settings.evaluationForms.properties.filledInBy.title')}>
			<Flex alignItems="center">
				<Party
					checked={
						field.value === graphql.EvaluationFillInBy.Employee ||
						field.value === graphql.EvaluationFillInBy.Both
					}
					onChange={() => {
						switch (field.value) {
							case graphql.EvaluationFillInBy.Employee:
								setValue(graphql.EvaluationFillInBy.Manager);
								break;
							case graphql.EvaluationFillInBy.Manager:
								setValue(graphql.EvaluationFillInBy.Both);
								break;
							case graphql.EvaluationFillInBy.Both:
								setValue(graphql.EvaluationFillInBy.Manager);
								break;
						}
					}}
					title={t('common.settings.evaluationForms.properties.filledInBy.employee')}
					name="employee"
				/>
				<Box width={20} />
				<Party
					checked={
						field.value === graphql.EvaluationFillInBy.Manager ||
						field.value === graphql.EvaluationFillInBy.Both
					}
					onChange={() => {
						switch (field.value) {
							case graphql.EvaluationFillInBy.Employee:
								setValue(graphql.EvaluationFillInBy.Both);
								break;
							case graphql.EvaluationFillInBy.Manager:
								setValue(graphql.EvaluationFillInBy.Employee);
								break;
							case graphql.EvaluationFillInBy.Both:
								setValue(graphql.EvaluationFillInBy.Employee);
								break;
						}
					}}
					title={t('common.settings.evaluationForms.properties.filledInBy.manager')}
					name="manager"
				/>
			</Flex>
		</Property>
	);
}
